import { guestKeySchema } from '@repo/api-contracts';

/** 비회원 키 보관 자리(G6) — 브라우저마다 하나. 비회원 이미지 업로드·표시·제출이 이 키로 소유를 확인한다. */
const STORAGE_KEY = 'superstructure.guest-key';

/** localStorage 를 못 쓰는 브라우저(사생활 보호 모드 등)용 — 이 탭이 살아 있는 동안만 같은 키를 쓴다. */
let memoryGuestKey: string | null = null;

/**
 * 이 브라우저의 비회원 키(UUID). 없거나 UUID 가 아니면 새로 만들어 둔다.
 * storage 가 던지면 메모리 키로 이어 간다 — 업로드한 이미지는 그 탭에서만 쓸 수 있다.
 */
export const getOrCreateGuestKey = (): string => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== null && guestKeySchema.safeParse(stored).success) return stored;
    const created = memoryGuestKey ?? crypto.randomUUID();
    memoryGuestKey = created;
    localStorage.setItem(STORAGE_KEY, created);
    return created;
  } catch {
    memoryGuestKey ??= crypto.randomUUID();
    return memoryGuestKey;
  }
};
